import { DealerLayout } from "@/components/shared/DealerLayout";
import { PDFFormFiller } from "@/components/shared/PDFFormFiller";
import { uploadPreApprovedDocument } from "@/lib/api";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;
const PDF_URL = `${API}/api/templates/mtc_form`;
const DISPLAY_PDF_URL = `${API}/api/templates/mtc_form?flatten=true`;

// Field definitions from extracted PDF annotations (page 0)
const FIELDS = [
  // Seller info (pre-filled)
  { id: "seller_name", page: 0, type: "text", rect: [99.2, 663.8, 544.2, 674.8], label: "Seller Name", defaultValue: "T-Cetra LLC" },
  { id: "seller_address", page: 0, type: "text", rect: [70.3, 640.9, 546.2, 651.8], label: "Seller Address", defaultValue: "7240 Muirfield Dr. Suite 200 Dublin OH 43017" },

  // Buyer info
  { id: "buyer_name", page: 0, type: "text", rect: [129.0, 606.8, 293.0, 617.8], label: "Buyer Name" },
  { id: "buyer_address", page: 0, type: "text", rect: [70.3, 595.3, 292.1, 606.0], label: "Buyer Address" },
  { id: "field_1", page: 0, type: "text", rect: [40.3, 583.2, 292.4, 594.1], label: "" },
  { id: "field_2", page: 0, type: "text", rect: [40.3, 571.7, 292.4, 582.6], label: "" },
  { id: "field_3", page: 0, type: "text", rect: [40.3, 560.3, 292.4, 571.2], label: "" },
  { id: "field_4", page: 0, type: "text", rect: [36.5, 549.7, 296.5, 559.8], label: "" },

  // Checkboxes
  { id: "cb_wholesaler", page: 0, type: "checkbox", rect: [342.4, 608.2, 352.3, 614.3], label: "Wholesaler" },
  { id: "cb_retailer", page: 0, type: "checkbox", rect: [342.4, 596.6, 352.3, 602.8], label: "Retailer", defaultValue: "on" },
  { id: "cb_manufacturer", page: 0, type: "checkbox", rect: [342.4, 585.1, 352.3, 591.2], label: "Manufacturer" },
  { id: "cb_seller", page: 0, type: "checkbox", rect: [342.4, 574.1, 352.3, 580.2], label: "Seller" },
  { id: "cb_lessor", page: 0, type: "checkbox", rect: [342.4, 562.3, 352.3, 568.4], label: "Lessor" },
  { id: "cb_other", page: 0, type: "checkbox", rect: [342.4, 550.0, 351.6, 556.1], label: "Other" },
  { id: "other_specify", page: 0, type: "text", rect: [419.8, 548.9, 498.5, 559.8], label: "Specify" },

  // Description
  { id: "desc_business", page: 0, type: "text", rect: [124.9, 489.2, 547.2, 500.2], label: "Description of Business", defaultValue: "Cell phones, bill payments, accessories" },
  { id: "prop_desc_1", page: 0, type: "text", rect: [366.1, 468.6, 547.2, 479.5], label: "Property Description 1", defaultValue: "Cell phones, bill payments, accessories" },
  { id: "prop_desc_2", page: 0, type: "text", rect: [37.2, 452.8, 550.4, 463.7], label: "Property Description 2" },

  // State registrations (left column)
  { id: "st_ak_ar", page: 0, type: "text", rect: [110.4, 409.8, 301.7, 421.9], label: "AK/AR/SS/TC" },
  { id: "st_al", page: 0, type: "text", rect: [110.4, 396.7, 301.7, 408.7], label: "AL" },
  { id: "st_ar", page: 0, type: "text", rect: [110.3, 385.7, 301.8, 395.8], label: "AR" },
  { id: "st_az", page: 0, type: "text", rect: [110.3, 374.9, 301.8, 384.7], label: "AZ" },
  { id: "st_ca", page: 0, type: "text", rect: [110.3, 364.1, 301.8, 373.9], label: "CA" },
  { id: "st_co", page: 0, type: "text", rect: [110.3, 353.3, 301.8, 363.1], label: "CO" },
  { id: "st_ct", page: 0, type: "text", rect: [110.3, 342.2, 301.8, 352.3], label: "CT" },
  { id: "st_fl", page: 0, type: "text", rect: [110.3, 331.4, 301.8, 341.3], label: "FL" },
  { id: "st_ga", page: 0, type: "text", rect: [110.3, 320.6, 301.8, 330.5], label: "GA" },
  { id: "st_hi", page: 0, type: "text", rect: [110.3, 309.8, 301.8, 319.7], label: "HI" },
  { id: "st_ia", page: 0, type: "text", rect: [110.3, 299.0, 301.8, 308.9], label: "IA" },
  { id: "st_id", page: 0, type: "text", rect: [110.3, 288.2, 301.8, 298.1], label: "ID" },
  { id: "st_il", page: 0, type: "text", rect: [110.3, 277.4, 301.8, 287.3], label: "IL" },
  { id: "st_ks", page: 0, type: "text", rect: [110.3, 266.6, 301.8, 276.5], label: "KS" },
  { id: "st_ky", page: 0, type: "text", rect: [110.3, 255.7, 301.8, 265.7], label: "KY" },
  { id: "st_me", page: 0, type: "text", rect: [110.3, 244.9, 301.8, 254.8], label: "ME" },
  { id: "st_md", page: 0, type: "text", rect: [110.3, 234.1, 301.8, 244.0], label: "MD" },
  { id: "st_mi", page: 0, type: "text", rect: [110.3, 223.3, 301.8, 233.2], label: "MI" },
  { id: "st_mn", page: 0, type: "text", rect: [110.3, 212.5, 301.8, 222.4], label: "MN" },

  // State registrations (right column)
  { id: "st_mo", page: 0, type: "text", rect: [343.2, 409.8, 535.2, 421.9], label: "MO" },
  { id: "st_ne", page: 0, type: "text", rect: [343.2, 396.7, 535.2, 408.7], label: "NE" },
  { id: "st_nv", page: 0, type: "text", rect: [343.1, 385.7, 535.3, 395.8], label: "NV" },
  { id: "st_nj", page: 0, type: "text", rect: [343.1, 374.9, 535.3, 384.7], label: "NJ" },
  { id: "st_nm", page: 0, type: "text", rect: [343.1, 364.1, 535.3, 373.9], label: "NM" },
  { id: "st_nc", page: 0, type: "text", rect: [343.1, 353.3, 535.3, 363.1], label: "NC" },
  { id: "st_nd", page: 0, type: "text", rect: [343.1, 342.2, 535.3, 352.3], label: "ND" },
  { id: "st_oh", page: 0, type: "text", rect: [343.1, 331.4, 535.3, 341.3], label: "OH" },
  { id: "st_ok", page: 0, type: "text", rect: [343.1, 320.6, 535.3, 330.5], label: "OK" },
  { id: "st_pa", page: 0, type: "text", rect: [343.1, 309.8, 535.3, 319.7], label: "PA" },
  { id: "st_ri", page: 0, type: "text", rect: [343.1, 299.0, 535.3, 308.9], label: "RI" },
  { id: "st_sc", page: 0, type: "text", rect: [343.1, 288.2, 535.3, 298.1], label: "SC" },
  { id: "st_sd", page: 0, type: "text", rect: [343.1, 277.4, 535.3, 287.3], label: "SD" },
  { id: "st_tn", page: 0, type: "text", rect: [343.1, 266.6, 535.3, 276.5], label: "TN" },
  { id: "st_tx", page: 0, type: "text", rect: [343.1, 255.7, 535.3, 265.7], label: "TX" },
  { id: "st_ut", page: 0, type: "text", rect: [343.1, 244.9, 535.3, 254.8], label: "UT" },
  { id: "st_vt", page: 0, type: "text", rect: [343.1, 234.1, 535.3, 244.0], label: "VT" },
  { id: "st_wa", page: 0, type: "text", rect: [343.1, 223.3, 535.3, 233.2], label: "WA" },
  { id: "st_wi", page: 0, type: "text", rect: [343.1, 212.5, 535.3, 222.4], label: "WI" },

  // Signature, Title, Date
  { id: "signature", page: 0, type: "signature", rect: [242.3, 104.5, 521.2, 115.4], label: "Authorized Signature" },
  { id: "title", page: 0, type: "text", rect: [199.3, 70.7, 546.1, 81.6], label: "Title" },
  { id: "date", page: 0, type: "text", rect: [199.4, 59.0, 545.2, 70.0], label: "Date" },

  // Notes (page 1)
  { id: "notes", page: 1, type: "text", rect: [36.0, 530.0, 222.1, 538.4], label: "Notes" },
];

// Map field IDs to actual PDF form field names for pdf-lib
const PDF_FIELD_MAPPING = {
  seller_name: "Issued to Seller",
  seller_address: "Address",
  buyer_name: "Name of Firm Buyer",
  buyer_address: "Address_2",
  field_1: "1",
  field_2: "2",
  field_3: "3",
  field_4: "undefined",
  other_specify: "undefined_2",
  desc_business: "Description of Business",
  prop_desc_1: "General description of tangible property or taxable services to be purchased from the Seller 1",
  prop_desc_2: "General description of tangible property or taxable services to be purchased from the Seller 2",
  title: "Title",
  date: "Date",
  notes: "Notes",
  // Checkboxes
  cb_wholesaler: "Wholesaler",
  cb_retailer: "Retailer",
  cb_manufacturer: "Manufacturer",
  cb_seller: "Seller",
  cb_lessor: "toggle_5",
  cb_other: "Other Specify",
  // State registrations
  st_ak_ar: "State Registration Sellers Permit or ID Number of PurchaserAKARSSTC 1",
  st_al: "State Registration Sellers Permit or ID Number of PurchaserAL 2",
  st_ar: "State Registration Sellers Permit or ID Number of PurchaserAR",
  st_az: "State Registration Sellers Permit or ID Number of PurchaserAZ 3",
  st_ca: "State Registration Sellers Permit or ID Number of PurchaserCA 4",
  st_co: "State Registration Sellers Permit or ID Number of PurchaserCO 56",
  st_ct: "State Registration Sellers Permit or ID Number of PurchaserCT 7",
  st_fl: "State Registration Sellers Permit or ID Number of PurchaserFL8",
  st_ga: "State Registration Sellers Permit or ID Number of PurchaserGA9",
  st_hi: "State Registration Sellers Permit or ID Number of PurchaserHI 510",
  st_ia: "State Registration Sellers Permit or ID Number of PurchaserIA",
  st_id: "State Registration Sellers Permit or ID Number of PurchaserID11",
  st_il: "State Registration Sellers Permit or ID Number of PurchaserIL 512",
  st_ks: "State Registration Sellers Permit or ID Number of PurchaserKS13",
  st_ky: "State Registration Sellers Permit or ID Number of PurchaserKY14",
  st_me: "State Registration Sellers Permit or ID Number of PurchaserME 15",
  st_md: "State Registration Sellers Permit or ID Number of PurchaserMD 16",
  st_mi: "State Registration Sellers Permit or ID Number of PurchaserMI 17",
  st_mn: "State Registration Sellers Permit or ID Number of PurchaserMN 18",
  st_mo: "State Registration Sellers Permit or ID Number of PurchaserMO 19",
  st_ne: "State Registration Sellers Permit or ID Number of PurchaserNE",
  st_nv: "State Registration Sellers Permit or ID Number of PurchaserNV 20",
  st_nj: "State Registration Sellers Permit or ID Number of PurchaserNJ",
  st_nm: "State Registration Sellers Permit or ID Number of PurchaserNM 521",
  st_nc: "State Registration Sellers Permit or ID Number of PurchaserNC 22",
  st_nd: "State Registration Sellers Permit or ID Number of PurchaserND",
  st_oh: "State Registration Sellers Permit or ID Number of PurchaserOH23",
  st_ok: "State Registration Sellers Permit or ID Number of PurchaserOK 24",
  st_pa: "State Registration Sellers Permit or ID Number of PurchaserPA 25",
  st_ri: "State Registration Sellers Permit or ID Number of PurchaserRI 26",
  st_sc: "State Registration Sellers Permit or ID Number of PurchaserSC",
  st_sd: "State Registration Sellers Permit or ID Number of PurchaserSD 27",
  st_tn: "State Registration Sellers Permit or ID Number of PurchaserTN 28",
  st_tx: "State Registration Sellers Permit or ID Number of PurchaserTX 29",
  st_ut: "State Registration Sellers Permit or ID Number of PurchaserUT",
  st_vt: "State Registration Sellers Permit or ID Number of PurchaserVT 30",
  st_wa: "State Registration Sellers Permit or ID Number of PurchaserWA 31",
  st_wi: "State Registration Sellers Permit or ID Number of PurchaserWI 32",
};

export default function MTCFormGenerator() {
  const navigate = useNavigate();

  return (
    <DealerLayout>
      <PDFFormFiller
        pdfUrl={PDF_URL}
        displayPdfUrl={DISPLAY_PDF_URL}
        fields={FIELDS}
        title="MTC Resale Certificate"
        subtitle="Fill in the fields directly on the document. Blue-highlighted areas are fillable."
        docType="mtc_form"
        onSave={(file, docType) => uploadPreApprovedDocument(file, docType).then(() => navigate("/dealer/documents"))}
        onBack={() => navigate("/dealer/documents")}
        pdfFieldMapping={PDF_FIELD_MAPPING}
      />
    </DealerLayout>
  );
}
